<div class="col-sm-2 report-generator-filter">
    <div class="report-generator-filter_view-part" (click)="showDropdown = !showDropdown">Filter</div>
    <div class="report-generator-filter_dropdown" [hidden]="!showDropdown">
        <div class="m-b-xs filter-checkbox">
            <label class="img-checkbox">
                <input type="checkbox" id="presetCheckbox" #presetCheckbox (change)="changeFilter()">
                <label for="presetCheckbox"><svg-checked></svg-checked></label>
                <span>Pre Set</span>
            </label>
        </div>

        <div class="m-b-xs filter-checkbox">
            <label class="img-checkbox">
                <input type="checkbox" id="customCheckbox" #customCheckbox (change)="changeFilter()">
                <label for="customCheckbox"><svg-checked></svg-checked></label>
                <span>Custom</span>
            </label>
        </div>
    </div>
</div>



// WEBPACK FOOTER //
// /app/src/app/components/report-generator-filter/report-generator-filter.component.html